/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TransactionReasonsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfGetReasonsResponse,
  PostReasonRequest,
  PutReasonRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockReasons = [
  { id: 1, name: 'Damaged', actionType: 'Waste', storeNumber: 'STORE001', isActive: true },
  { id: 2, name: 'Expired', actionType: 'Waste', storeNumber: 'STORE001', isActive: true },
  { id: 3, name: 'Stock Adjustment', actionType: 'Adjustment', storeNumber: 'STORE001', isActive: true },
  { id: 4, name: 'Received Goods', actionType: 'Receipt', storeNumber: 'STORE001', isActive: true },
  { id: 5, name: 'Transfer Out', actionType: 'Transfer', storeNumber: 'STORE001', isActive: true },
];

/* ---- Mocked Client Implementation ---- */

import { ITransactionReasonsClient } from '../../interfaces';
export class TransactionReasonsClientMocked implements ITransactionReasonsClient {
  constructor(baseUrl?: string) {}

  async reasonsGET(actionType?: string, storeNumber?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfGetReasonsResponse> {
    await delay();
    let filtered = [...mockReasons];

    if (actionType) {
      filtered = filtered.filter((r) => r.actionType === actionType);
    }
    if (storeNumber) {
      filtered = filtered.filter((r) => r.storeNumber === storeNumber);
    }

    return successResponse({ reasons: filtered }) as SuccessResponse_1OfGetReasonsResponse;
  }

  async reasonsPOST(storeNumber?: string, body?: PostReasonRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockReasons.push({
        id: mockReasons.length + 1,
        name: body.name || 'New Reason',
        actionType: body.actionType || 'Custom',
        storeNumber: storeNumber || 'STORE001',
        isActive: body.active ?? true,
      });
    }
  }

  async reasonsPUT(id: number, body?: PutReasonRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const reason = mockReasons.find((r) => r.id === id);
    if (reason && body) {
      reason.actionType = body.actionType || reason.actionType;
    }
  }

  async reasonsDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockReasons.findIndex((r) => r.id === id);
    if (index > -1) {
      mockReasons.splice(index, 1);
    }
  }

  // ====== Auto-generated stub methods ======






}
